import { WebchatMessage } from "@/components/molecules/interactionWorkspace";
import { InfiniteQueryFnParams } from "@/hooks/infiniteQuery";
import { mapUrl, Client } from "../client";
import { Endpoint } from "../endpoint";
import { ExtendedPagedResult } from "../pagedResult";
import { Controller } from "../controller";
import {
	WebchatReplyMessageModel,
	FileUploadSasUrlRequest,
	FileUploadSasUrlResponse,
} from "../models/message";

export const WebchatMessagesKey = "WebchatMessages";
export const WebchatHistoryMessagesKey = "WebchatHistoryMessages";

export const fetchWebchatMessages = ({
	page: page,
	searchValue,
	sessionId,
}: InfiniteQueryFnParams): Promise<ExtendedPagedResult<WebchatMessage>> => {
	if (!sessionId) {
		return Promise.reject(new Error("sessionId is required"));
	}

	const query = {
		page,
		pageSize: 10,
		searchValue,
	};

	const url = mapUrl(Controller.Webchat, sessionId, Endpoint.Messages);

	return Client.instance.get(url, query);
};

export const fetchWebchatHistoryMessages = ({
	page: page,
	searchValue,
	sessionId,
}: InfiniteQueryFnParams): Promise<ExtendedPagedResult<WebchatMessage>> => {
	if (!sessionId) {
		return Promise.reject(new Error("sessionId is required"));
	}

	const query = {
		page: page,
		pageSize: 10,
		searchValue,
	};

	const url = mapUrl(
		Controller.Webchat,
		"history",
		sessionId,
		Endpoint.Messages
	);

	return Client.instance.get(url, query);
};

export const sendTextMessage = (
	sessionId: string,
	replyModel: WebchatReplyMessageModel
) => {
	const url = mapUrl(Controller.Webchat, sessionId, Endpoint.Reply);

	return Client.instance.post<string>(url, replyModel);
};

export const generateUploadUrls = async (
	uploadUrlRequests: FileUploadSasUrlRequest[],
	conversationId: string
): Promise<FileUploadSasUrlResponse[]> => {
	try {
		const url = mapUrl(
			Controller.Media,
			Endpoint.Webchat,
			conversationId,
			Endpoint.UploadUrl
		);

		return Client.instance
			.post<FileUploadSasUrlResponse[]>(url, uploadUrlRequests)
			.then((response) => response);
	} catch (error) {
		console.error("Error fetching SAS URL:", error);
		throw error;
	}
};
